import { MasterView } from "../shared/views/master-view";
import { MyJustisView } from "./views/my-justis";
import { ApplicationInsights } from "../shared/helpers/application-insights";
import { autoinject } from "aurelia-dependency-injection";
import { AuthService } from "../authentication/auth-service";

const dom = {
    SUB_REGION: "#overview-region",
    OVERVIEW_BUTTON: ".overview-button",
    HISTORY_REGION: "#history-region",
    HISTORY_BUTTON: ".history-button",
    ALERTING_REGION: "#alerting-region",
    ALERTING_BUTTON: ".alerting-button",
    BUNDLES_REGION: "#bundles-region",
    BUNDLES_BUTTON: ".bundles-button",
};

@autoinject
export class MyJustisModule extends Backbone.Model {

    constructor(
        private appEvents: Backbone.Events,
        private appInsights: ApplicationInsights,
        private myJustisView: MyJustisView,
        private masterView: MasterView,
        private authService: AuthService
    ) {
        super();
        this.setupViews();
    }

    public hide(): void {
        $("#viewport-content").removeClass("my-justis");
    }

    public show(section?: string, subsection?: string) {
        $("#viewport-content").addClass("my-justis");
        this.myJustisView.showSection(section, subsection);

    }

    private setupViews() {
        this.listenToOnce(this.masterView, "show", () => {
            const myJustisRegion = this.masterView.addRegion("myJustis", "#my-justis-region");
            myJustisRegion.show(this.myJustisView);
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/my-justis-module.ts